import React from 'react';
import { useBeats } from '../../hooks/useBeats';
import { accumulation } from '../../data/teaser';
const BEATS = [300, 900, 1500, 1800, 2100, 2700];
export function ScreenReward() {
  const beat = useBeats(BEATS);
  return <section className="flex h-full w-full flex-col justify-center" data-id="element-80" data-mp="3ljeuptwcydif">
      <h1 className="text-4xl font-extrabold leading-tight text-white animate-fade-in-up" data-id="element-81" data-mp="3qjsrugwf831o">
        More precision.
        <br data-id="element-82" data-mp="3vhb34dxwuucu" />
        <span className="text-solventum-primary" data-id="element-83" data-mp="3vhkua4uoz7k4">Less chair time.</span>
      </h1>

      <div className={`mt-6 transition-all duration-300 ${beat >= 1 ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'}`} data-id="element-84" data-mp="3di94ghmrxmo">
        <p className="font-headline text-[72px] font-extrabold leading-none tabular-nums text-solventum-primary" data-id="element-85" data-mp="d4d5wesi6fmd">
          12
        </p>
        <p className="mt-1 font-headline text-xl font-extrabold leading-snug text-white" data-id="element-86" data-mp="i4ivzqj4ju2c">
          minutes saved per bonding procedure, on average.
        </p>
      </div>

      <p className={`mt-4 font-headline text-xl font-extrabold leading-snug text-white transition-all duration-300 ${beat >= 2 ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'}`} data-id="element-87" data-mp="1s3qpkib7t86x">
        Not once. <span className="text-solventum-primary" data-id="element-88" data-mp="1i5t4u4skdtj2">Every time you bond a case.</span>
      </p>

      <div className="mt-5 flex items-center gap-2" data-id="element-89" data-mp="1e4rbu5p8qdpj">
        {accumulation.map((row, index) => <div key={row.cases} className={`flex-1 rounded-xl border border-white/10 bg-white/[0.04] px-3 py-2.5 text-center transition-all duration-300 ${beat >= index + 3 ? 'translate-y-0 opacity-100' : 'translate-y-1.5 opacity-0'}`} data-id="element-90" data-mp="2asdtgxhnnrix" data-mpi={index}>
            <p className="font-body text-[11px] text-white/50" data-id="element-91" data-mp="1x07nu5c4p2xq">{row.cases}</p>
            <p className="mt-0.5 font-headline text-lg font-extrabold tabular-nums text-solventum-primary" data-id="element-92" data-mp="2tlreoavkgjlc">
              {row.gain}
            </p>
          </div>)}
      </div>

      <div className={`mt-6 border-t border-white/10 pt-5 transition-all duration-300 ${beat >= 6 ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'}`} data-id="element-93" data-mp="mx9059lh8sn9">
        <p className="font-headline text-lg font-extrabold leading-snug text-white" data-id="element-94" data-mp="d5367ubo015f">
          30 seconds invested.
          <br data-id="element-95" data-mp="i3mwu817e144" />
          <span className="text-solventum-primary" data-id="element-96" data-mp="i34pogd062hf">
            12 minutes returned. Again and again.
          </span>
        </p>

        <button className="mt-4 w-full rounded-2xl bg-solventum-primary px-6 py-4 font-headline text-lg font-extrabold text-solventum-bg shadow-[0_0_24px_rgba(5,221,77,0.25)] transition-transform duration-150 active:scale-[0.98]" data-id="element-97" data-mp="949ndfd2xcje">
          See Precision Grip in action →
        </button>
      </div>
    </section>;
}